<template>
  <v-dialog class="edit-wrapper"  title="Edit a meeting push" :visible.sync="dialogVisible" width="65vw" @open="onOpen"
    @closed="onClosed">
    <el-form v-loading="loading" class="padding-lr" ref="form" :model="form" :rules="editMeetingFormRules" label-width="130px">
      <el-form-item label="Greetings" prop="greeting">
        <el-input class="greet-input" v-model="form.greeting" maxlength="20" />
      </el-form-item>
      <el-form-item ref="pushToMSL" label="Setting" prop="pushToMSL" style="margin-bottom: 5px!important;">
        <div>
          <el-checkbox v-model="form.pushToMSL" :disabled="disablePushToMSL">Push to Me</el-checkbox>
          <el-button v-if="disablePushToMSL" class="bind-wechat-link" type="text" @click="bindWeChat()">
            Bind WeChat?
          </el-button>
        </div>
        <div class="push-to-msl-msg" slot="error">{{ pushToMSLMsg }}</div>
      </el-form-item>

      <el-form-item ref="isWeComSend" prop="isWeComSend" style="margin-bottom: 5px!important;">
        <div class="checkbox-wrapper">
                <el-checkbox v-model="form.isWeComSend">WeCom Send</el-checkbox>
                <el-checkbox v-if="form.isWeComSend" v-model="form.contactsOnly" @change="onContactsOnlyChange">Contacts Only</el-checkbox>
              </div>
      </el-form-item>

      <el-form-item label="Tag">
        <HcpTagSelect v-model="selectedTagIds" />
      </el-form-item>
      <el-form-item prop="seIds" :label="formItemLabel">
        <el-radio-group v-model="seType" @input="changeSeType" v-if="isSupervisor || isMSL">
          <el-radio label="All">All</el-radio>
          <el-radio label="SE">SE</el-radio>
          <el-radio label="CE">CE</el-radio>
        </el-radio-group>
        <SEMultipleSelect v-model="form.seIds" :showTips="true" :placeholder="selectPlaceholder" :options="seListByType"
          :showTag="false" type='push' @select-change="onSESelectChange" />
        <div class="selected-hcp-count">Selected: <strong>{{ form.seIds.length }}</strong></div>
      </el-form-item>
      <el-form-item label="Select Meeting" prop="meetingId">
        <el-select @change="onMeetingSelectChange" v-model="form.meetingId" placeholder="Please select Meeting">
          <el-option v-for="(item, index) in meetingTitleList" :label="item.Title" :value="item.MeetingId" :key="index">
            <span style="float: left">{{ item.Title }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              item.range
            }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="Request Content" prop="requestId" v-if="isVMSL">
        <el-select filterable v-model="form.requestId" placeholder="Please select request content">
          <el-option v-for="(item, index) in requestContentList" :label="item.Name" :value="item.Id" :key="index">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="meetingRequestType" class="request-type">
        <el-radio-group v-model="form.meetingRequestType" @change="onRequestTypeChange">
          <div v-for="type in pushTypes" :key="type.key">
            <el-radio :label="type.key" :key="type.key" style="line-height: 32px;">{{ type.value }}</el-radio>
            <template v-if="form.meetingRequestType === type.key && type.key === 0">
              <el-input v-model="form.requestContent" placeholder="Please input reason" />
            </template>
            <template v-if="form.meetingRequestType === type.key && type.key === 1">
              <el-row type="flex" align="bottom" :gutter="20">
                <el-col class="interaction-date-time">
                  <el-form-item prop="interactionDateTime" label="Interaction date/time" class="label-top">
                    <div class="datetime">
                      <el-date-picker v-model="iDate" type="date" :format="dateFormat" :value-format="dateFormat"
                        placeholder="Date" :editable="false" />
                      <el-select class="times-select" v-model="iTime" clearable allow-create filterable
                        placeholder="Time" @blur="onTimeBulr($event, 'iTime')" ref="iTime">
                        <i slot="prefix" class="el-input__icon el-icon-time"></i>
                        <el-option v-for="(item, i) in times" :key="i" :label="item.value" :value="item.value" />
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col class="interaction-type">
                  <el-form-item prop="interactionTypeId" label="Interaction type" class="label-top">
                    <el-select v-model="form.interactionTypeId" placeholder="Interaction type">
                      <el-option v-for="t in interTypes" :label="t.value" :value="t.key" :key="t.key" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="Request Content" class="label-top">
                <el-input v-model="form.requestContent" type="textarea" rows="3" :maxlength="200"
                  style="width: 100% !important" />
              </el-form-item>
            </template>
            <template v-if="form.meetingRequestType === type.key && type.key === 6">
              <el-input v-model="form.requestContent" placeholder="Please input reason" />
              <CheckboxGroup v-model="form.initActivities" class="activity_options">
                <Checkbox v-for="activity in activityOptions" :key="activity.optionId" :label="activity.optionId">
                  {{ activity.optionValue }}
                </Checkbox>
              </CheckboxGroup>
            </template>
          </div>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="Request Content" prop="requestContent" v-if="isMSL">
             <el-input v-model="form.requestContent" type="textarea" :rows="2"
                placeholder="Please input request content" />
            </el-form-item> -->
      <el-form-item label="Content" class="editor" prop="paperContent">
        <TinymceEditor v-if="visible" :height="300" v-model="form.paperContent" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="footer">
      <el-button type="primary" @click="onSubmit(1)" :disabled="actionDisabled">
        Submit
      </el-button>
      <el-button @click="onSubmit(0)" :disabled="actionDisabled">
        Save Draft
      </el-button>
    </div>
    <!-- 自定义HCP确认对话框 -->
    <el-dialog title="请确认推送的HCP" :visible.sync="customConfirmVisible" width="500px" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false" class="custom-confirm-dialog">
      <div class="confirm-dialog-content">
        <div class="confirm-section" v-if="confirmedContactsNames.length > 0">
          <div class="confirm-title">已添加MSL企业微信联系人：{{ confirmedContactsNames }}</div>
          <div class="confirm-hint">(可推送至医生微信)</div>
        </div>
        <div class="confirm-divider" v-if="unconfirmedContactsNames.length > 0 && confirmedContactsNames.length > 0">
        </div>
        <div class="confirm-section" v-if="unconfirmedContactsNames.length > 0">
          <div class="confirm-title">未添加MSL企业微信联系人： {{ unconfirmedContactsNames }}</div>
          <div class="confirm-hint">(不可推送至医生微信)</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customConfirmCancel">Cancel</el-button>
        <el-button type="primary" @click="customConfirmSubmit">Submit</el-button>
      </span>
    </el-dialog>
  </v-dialog>
</template>
<script>
import TinymceEditor from '../../components/tinymce-editor'
import { RoleCode } from "@/utils/role-constant";
import { trimValidate } from '../../utils/validator'
import SEMultipleSelect from "../../components/se-multiple-select";
import HcpTagSelect from "../../components/hcp-tag-select.vue";
import { hcpMatchesTagFilter } from "@/utils/hcp-tag-catalog";
import { CheckboxGroup, Checkbox } from 'element-ui';
import { getTimes } from "../../utils/datetime";

export default {
  name: 'create-meeting-content-dialog',
  components: { TinymceEditor, SEMultipleSelect, HcpTagSelect, CheckboxGroup, Checkbox },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
      const validatePushToMSL = (rule, value, callback) => {
        if (
          this.isSelectSEUncertified &&
          !this.pushToMSL &&
          !value
        ) {
          return callback(new Error());
        }
        callback();
      };
      return {
        loading:false,
        isSelectSEUncertified: false,
        seType: 'All',
        selectedTagIds: [],
        dialogVisible: this.visible,
        dateFormat: "yyyy-MM-dd",
        timeFormat: "HH:mm",
        customConfirmVisible: false,
        // 保存原始的seList数据，用于contactsOnly勾选/取消时恢复
        originalSeList: null,
        confirmedContacts: [],
        unconfirmedContacts: [],
        form: {
          isWeComSend: false,
          contactsOnly: false,
          pushToMSL: false,
          status: '', // 0 drafft  1 submit
          greeting: '',
          seIds: [],
          shortTitle: '',
          meetingId: '',
          paperContent: '',
          paperId: '',
          requestId: '',
          requestContent: '',
          meetingRequestType: "",
          interactionTypeId: null,
          interactionDateTime: null,
          initActivities: []
        },
      seList: [],
      meetingTitleList: [],
      editMeetingFormRules: {
        greeting: [
          {
            required: true,
            validator: trimValidate('Please input greetings'),
            message: 'Please input greetings',
            trigger: 'blur',
          },
        ],
        interactionDateTime: [
          {
            required: true,
            message: "Please select interaction date and time",
            tigger: "change",
          },
        ],
        interactionTypeId: [
          {
            required: true,
            message: "Please select interaction type",
            tigger: "change",
          },
        ],
        pushToMSL: {
          type: "boolean",
          required: false,
          trigger: "change",
          validator: validatePushToMSL,
        },
        // requestContent: [
        //   {
        //     required: true,
        //     validator: trimValidate('Please input request content'),
        //     trigger: 'blur',
        //   },
        // ],
        seIds: [
          { required: true, message: 'Please select HCP', trigger: 'change' },
        ],
        meetingId: [
          {
            required: true,
            message: 'Please select meeting title',
            trigger: 'change',
          },
        ],
        // requestId: [
        //   {
        //     required: true,
        //     validator: trimValidate('Please input request content'),
        //     trigger: 'change',
        //   },
        // ],
        paperContent: [
          { required: true, message: 'Please input content', trigger: 'blur' },
        ],
      },
      actionDisabled: false,
      // requestContentList: []
      iDate: "", // interaction date
      iTime: "", // interaction time
      initRequestContent: "",
      initRequestType: "",
      initIDate: "",
      initITime: "",
      initInteractionTypeId: null,
      originActivities: [],
      interTypes: [],
      pushTypes: [],
      activityOptions: [],
    }
  },
  computed: {
    seListByType() {
      let list = this.seList
      if (this.seType !== 'All') {
        list = list.filter(item => item.types ? item.types.includes(this.seType) : false)
      }
      if (this.selectedTagIds.length) {
        list = list.filter(item => hcpMatchesTagFilter(item.Tags, this.selectedTagIds))
      }
      return list
    },
    isSupervisor() {
      return this.$store.state.role === RoleCode.Supervisor
    },
    isMSL() {
      return this.$store.state.role === RoleCode.ML;
    },
    isVMSL() {
      return this.$store.state.role === RoleCode.VMSL;
    },
    confirmedContactsNames() {
      return this.confirmedContacts.join(', ');
    },
    unconfirmedContactsNames() {
      return this.unconfirmedContacts.join(', ');
    },
    token() {
      return this.$store.state.token
    },
    nameLabel() {
      const role = this.$store.state.role;
      return role === RoleCode.VMSL
        ? "vCE"
        : "HCP";
    },
    formItemLabel() {
      return `Select ${this.nameLabel}`;
    },
    selectPlaceholder() {
      return `Please select ${this.nameLabel.toLowerCase()}`;
    },
    times() {
      return getTimes("00:00", "23:30", "00:30", "00:00", "23:30");
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    disablePushToMSL() {
      return this.userInfo.bindStatus !== 2;
    },
    pushToMSLMsg() {
      return this.disablePushToMSL
        ? `Please bind WeChat first then check 'Push to Me' option`
        : this.form.pushToMSL
          ? ""
          : `Please check 'Push to Me' option`;
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
    dialogVisible(value) {
      this.$emit('update:visible', value)
    },
    selectedTagIds() {
      const validIds = this.seListByType.map(item => item.SEID)
      this.form.seIds = this.form.seIds.filter(id => validIds.includes(id))
    },
    iDate(value) {
      this.form.interactionDateTime =
        value && this.iTime ? `${value} ${this.iTime}` : "";
    },
    iTime(value) {
      this.form.interactionDateTime =
        value && this.iDate ? `${this.iDate} ${value}` : "";
    },
    'form.meetingRequestType'(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal !== this.initRequestType) {
          this.form.requestContent = '';
          this.form.initActivities = [];
          this.iDate = "";
          this.iTime = "";
          this.form.interactionTypeId = this.interTypes[0].key
        } else {
          this.form.requestContent = this.initRequestContent;
          this.form.initActivities = this.originActivities;
          this.iDate = this.initIDate;
          this.iTime = this.initITime;
          this.form.interactionTypeId = this.initInteractionTypeId;
        }
      }
    },
  },
  created() {
    this.editMeetingFormRules.seIds.message = this.selectPlaceholder;
  },
  methods: {
    onSESelectChange({ isUncertified }) {
      this.isSelectSEUncertified = isUncertified;
      this.$set(
        this.editMeetingFormRules.pushToMSL,
        "required",
        this.isSelectSEUncertified
      );
      if (this.isSelectSEUncertified) {
        this.$refs.form.validateField("pushToMSL");
      } else {
        this.$refs.pushToMSL.clearValidate();
      }
    },
    bindWeChat() {
      this.bus.$emit("bindWeChat");
    },
    changeSeType() {
      this.form.seIds = []
    },
    requestContent() {
      this.axios.get('/quickPush/meetingRequestType').then(({ code, data, msg }) => {
        if (code === 200) {
          this.requestContentList = data
        } else {
          this.$message.error(msg)
        }
      })
    },
    onClosed() {
      this.seType = 'All'
      this.actionDisabled = false
      this.form.shortTitle = ''
      this.editMeetingFormRules.interactionDateTime[0].required = false;
      this.editMeetingFormRules.interactionTypeId[0].required = false;
      this.form.requestContent = "";
      this.iDate = "";
      this.iTime = "";
      this.isSelectSEUncertified = false;
      this.form.isWeComSend = false;
      this.form.contactsOnly = false;
      this.$set(this.editMeetingFormRules.pushToMSL, "required", false);
      this.$refs.form.resetFields()
      this.$emit('update:data', null)
    },
    async onOpen() {
      this.seType = 'All'
      this.loading = true
      await this.getSEList()
      this.form.pushToMSL = this.$store.state.userInfo.bindStatus === 2;
      // this.requestContent()
     await this.$axios
        .all([
          this.axios.get("/combinePush/param")
        ])
        .then((res) => {
          console.log('getParam api')
          this.handleParamsResp(res[0])
        });
      this.getMeetingTitleList()
      if (this.data) {
        await this.getEditMeetingData()
        this.form.pushToMSL = this.data.PushToMSL;
        this.form.isWeComSend = this.data.IsWeComSend==1;
        this.form.contactsOnly = this.data.ContactsOnly==1;
        // this.onContactsOnlyChange(this.form.contactsOnly)
        this.loading =false
      }
      this.loading =false
      this.editMeetingFormRules.interactionDateTime[0].required = true;
      this.editMeetingFormRules.interactionTypeId[0].required = true;
      if (!this.isVMSL) {
        this.editMeetingFormRules.requestContent = [
          {
            required: true,
            validator: trimValidate('Please input request content'),
            trigger: 'blur',
          },
        ]
      }
    },
    getEditMeetingData() {
      let api = '/push/messageContent'
      let params = {
        messageHeadId: this.data.MessageHeadID,
      }
      if (this.data.BatchID) {
        api = '/push/batchMeetingContent'
        params = {
          batchId: this.data.BatchID,
        }
      }
      this.axios
        .get(api, {
          params
        })
        .then(({ code, data, msg }) => {
          if (code === 200) {
            console.log('getEditMeetingData api')
            const { MessageTitle, sePaparList, RequestId } = this.data
            const { InteractionDateTime, InteractionTypeId, InitActivities, meetingRequestType, RequestContent } = data.content[0]
            this.form.greeting = MessageTitle
            this.form.seIds = data.seIds
            // this.form.pushToMSL = data.PushToMSL;
            this.form.meetingId = data.content[0].MeetingID
            this.form.shortTitle = data.content[0].ShortTitle
            this.form.requestId = RequestId || data.RequestId
            // this.form.requestContent = RequestContent || data.RequestContent
            this.form.paperContent = data.content[0].PaperContent
            this.form.paperId = data.content[0].PaperID
            this.form.sePaparList = sePaparList
            if (meetingRequestType === 1) {
              let formateDate = this.moment(InteractionDateTime).format(
                this.dateFormat.toUpperCase()
              );
              let formateTime = this.moment(InteractionDateTime).format(this.timeFormat);
              this.iDate = formateDate === 'Invalid date' ? "" : formateDate
              this.iTime = formateTime === 'Invalid date' ? "" : formateTime
              this.form.interactionTypeId = InteractionTypeId;
              this.initInteractionTypeId = InteractionTypeId;
              this.initIDate = formateDate === 'Invalid date' ? "" : formateDate
              this.initITime = formateTime === 'Invalid date' ? "" : formateTime
              this.form.requestContent = RequestContent;
              this.setTimeInputListener("iTime");
            }
            this.initRequestContent = RequestContent;
            this.initRequestType = meetingRequestType;
            this.originActivities = InitActivities;
            this.form.requestContent = RequestContent;
            this.form.meetingRequestType = meetingRequestType;
            
            // 初始化originalSeList，保存完整的seList数据
            // 这样在contactsOnly勾选时可以正确过滤
            this.originalSeList = JSON.parse(JSON.stringify(this.seList));
            
            // 如果contactsOnly为true，需要立即执行过滤
            if (this.form.contactsOnly) {
              this.handleContactsOnlyFilter();
            }
          } else {
            this.$message.error(msg)
          }
        })
    },
    onSubmit(status) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.meetingRequestType === 6) {
            let noneReason = this.form.requestContent == '' || this.form.requestContent == null
            let noneActivity = this.form.initActivities.length == 0
            if (noneReason && noneActivity) {
              this.$message.error(
                "Please make sure you have input reason or check the checkbox for initiated activities"
              );
              return;
            }
          }
          this.actionDisabled = true
          this.form.status = status
          if (status != 0) {
            // 检查是否选中了contactsOnly选项
            if (this.form.isWeComSend && !this.form.contactsOnly) {
              // 显示自定义的HCP确认对话框
              this.confirmedContacts = this.seList.filter(se => this.form.seIds.includes(se.SEID) && se.IsWeComEnabled).map(se => se.Name);
              this.unconfirmedContacts = this.seList.filter(se => this.form.seIds.includes(se.SEID) && !se.IsWeComEnabled).map(se => se.Name);    
        
              this.customConfirmVisible = true;
            } else {
              // 显示原来的确认对话框
              this.$confirm('请确认推送给HCP。', '', {
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                type: 'warning'
              }).then(() => {
                this.goToSubmit(status);
              }).catch(() => {
                this.actionDisabled = false;
                return false;
              });
            }
          } else {
             let weComTypeList = this.form.seIds.map(seId => {
        let se = this.seList.find(se => se.SEID === seId);
        return {
          SEID: seId,
          IsWeComEnabled: se.IsWeComEnabled,
          Name: se.Name,
          ExternalUserId: se.ExternalUserId,
        }
      })
            this.axios
              .post('/push/updateMeetingPush', {
                ...this.form,
                greeting: this.form.greeting.trim(),
                requestId: this.form.requestId,
                requestContent: this.form.requestContent,
                messageHeadId: this.data.MessageHeadID,
                batchId: this.data.BatchID,
                  weComTypeList: weComTypeList,
              })
              .then(({ code, msg }) => {
                if (code == 200) {
                  this.$emit('success')
                  this.$message.success(
                    `${status === 1 ? 'Submit' : 'Save draft'} successfully`
                  )
                  this.dialogVisible = false
                } else if (code === 201) {
                  this.dialogVisible = false
                  this.$message.error(msg)
                } else {
                  this.$message.error(msg)
                  this.actionDisabled = false
                }
              })
              .catch(() => {
                this.actionDisabled = false
              })
          }
        } else {
          return false
        }
      })
    },
    // 提交到服务器
    goToSubmit(status) {
      let weComTypeList = this.form.seIds.map(seId => {
        let se = this.seList.find(se => se.SEID === seId);
        return {
          SEID: seId,
          IsWeComEnabled: se.IsWeComEnabled,
          Name: se.Name,
          ExternalUserId: se.ExternalUserId,
        }
      })
      this.axios
        .post('/push/updateMeetingPush', {
          ...this.form,
          greeting: this.form.greeting.trim(),
          requestId: this.form.requestId,
          requestContent: this.form.requestContent,
          messageHeadId: this.data.MessageHeadID,
          batchId: this.data.BatchID,
          weComTypeList: weComTypeList,
        })
        .then(({ code, msg }) => {
          if (code == 200) {
            this.$emit('success')
            this.$message.success(
              `${status === 1 ? 'Submit' : 'Save draft'} successfully`
            )
            this.dialogVisible = false
          } else if (code === 201) {
            this.dialogVisible = false
            this.$message.error(msg)
          } else {
            this.$message.error(msg)
            this.actionDisabled = false
          }
        })
        .catch(() => {
          this.actionDisabled = false
        })
    },
    // 自定义确认对话框的提交方法
    customConfirmSubmit() {
      this.customConfirmVisible = false;
      this.goToSubmit(1);
    },
    // 自定义确认对话框的取消方法
    customConfirmCancel() {
      this.customConfirmVisible = false;
      this.actionDisabled = false;
    },
    async getSEList() {
      await this.axios.get('/combinePush/seList').then(({ code, data, msg }) => {
        if (code === 200) {
          this.seList = data.filter(item => item.Certified == 1)
          console.log('getSEList api')
        } else {
          this.$message.error(msg)
        }
      })
    },
    getMeetingTitleList() {
      this.axios.get('content/meetingList').then(({ code, data, msg }) => {
        if (code === 200) {
          this.meetingTitleList = Array.from(data, (item) => {
            const format = 'YYYY-MM-DD HH:mm:ss'
            let range = `${this.moment(item.StartTime).format(
              format
            )} ~ ${this.moment(item.EndTime).format(format)}`
            item.labelRange = `${item.Title} (${range})`
            item.range = range
            return item
          })
        } else {
          this.$message.error(msg)
        }
      })
    },
    onMeetingSelectChange(value) {
      let meeting = this.meetingTitleList.find((i) => i.MeetingId == value)
      if (meeting) {
        const date = this.moment(meeting.StartTime).format('MM/DD/YYYY')
        const time = this.moment(meeting.StartTime).format('HH:mm:ss')
        this.form.paperContent = `<p>会议时间：${date} ${time} </p><p><a href="${meeting.MeetingLink}" title="加入会议">加入会议</a></p>`
        this.form.shortTitle = meeting.Title
        this.$refs.form.clearValidate('paperContent')
      }
    },
    handleParamsResp({ code, data }) {
      if (code === 200) {
        this.pushTypes = data.pushType;
        this.activityOptions = data.initActivitiesParams;
        this.interTypes = data.interType;
        this.form.interactionTypeId =
          data.interType.length > 0 ? data.interType[0].key : "";
      }
    },
    setTimeInputListener(ref) {
      this.$nextTick(() => {
        // const timeDom = this.$refs[ref];
        let refsData = this.$refs[ref];
        const timeDom = Array.isArray(refsData) ? refsData[0] : refsData;
        if (timeDom) {
          const input = timeDom.$refs.reference;
          input.$on("input", (value) => {
            value = value.length > 5 ? value.substring(0, 5) : value;
            value = value.replace(/[^0-9:\uff1a]/g, "").replace(/\uff1a/g, ":");
            timeDom.$set(timeDom, "selectedLabel", value);
          });
        }
      });
    },
    onRequestTypeChange(value) {
      // editMeetingFormRules
      this.editMeetingFormRules.interactionDateTime[0].required = value === 1;
      this.editMeetingFormRules.interactionTypeId[0].required = value === 1;
      this.form.initActivities = [];
      if (value === 0) {
        this.iDate = "";
        this.iTime = "";
        this.form.interactionTypeId = null;
      }
      if (value === 1) {
        this.setTimeInputListener("iTime");
      }
    },
    onTimeBulr(e, ref) {
      let timeDom = this.$refs[ref];
      if (timeDom) {
        const reg = /([01]?[0-9]|2[0-3]):[0-5][0-9]/;
        if (timeDom.selectedLabel) {
          if (reg.test(timeDom.selectedLabel)) {
            this.$set(this, ref, timeDom.selectedLabel);
          } else {
            timeDom.deleteSelected(e);
          }
        }
      }
    },
    
    // Contacts Only复选框变化处理
    onContactsOnlyChange(checked) {
      if (checked) {
        // 过滤seList中weComEnable为true的HCP，并更新到原始seList
        // 先保存原始seList到一个临时变量，以便取消勾选时恢复
        if (!this.originalSeList) {
          this.originalSeList = JSON.parse(JSON.stringify(this.seList));
        }
        
        // 过滤seList，只保留weComEnable为true的项
        const filteredSeList = this.originalSeList.filter(se => se && se.IsWeComEnabled);
        this.seList = filteredSeList;
        
        // 获取过滤后的seList中存在的HCP ID
        const validSeIds = filteredSeList.map(se => se.SEID);
        
        // 如果有选中的HCP，先检查是否有不支持的HCP，再过滤
        if (this.form.seIds.length > 0) {
          // 保存当前选中的HCP ID，用于检查
          const currentSeIds = [...this.form.seIds];
          
          // 检查选中的HCP中是否有weComEnable为false或不在过滤列表中的
          const hasUnsupportedContacts = currentSeIds.some(seId => {
            const se = this.originalSeList.find(s => s.SEID === seId);
            return se && !se.IsWeComEnabled || !validSeIds.includes(seId);
          });
          
          // 情况3：存在weComEnable为false或不在过滤列表中的HCP，需要弹窗确认
          if (hasUnsupportedContacts) {
            this.$confirm('已选择的HCP中有部分HCP没有添加企业微信，勾选”Contacts Only"后，没有添加企业微信的HCP将被过滤，请确认是否继续？', '提示', {
              confirmButtonText: '确定',
            cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // 用户同意，过滤掉不支持的HCP
              this.form.seIds = currentSeIds.filter(seId => validSeIds.includes(seId));
            }).catch(() => {
              // 用户拒绝，不勾选contactsOnly，并恢复原始seList
              this.form.contactsOnly = false;
              if (this.originalSeList) {
                this.seList = JSON.parse(JSON.stringify(this.originalSeList));
                this.form.seIds = currentSeIds
                this.originalSeList = null;
              }
              return; // 提前返回，避免后续代码执行
            });
          } else {
            // 没有不支持的HCP，直接过滤form.seIds
            this.form.seIds = currentSeIds.filter(seId => validSeIds.includes(seId));
          }
        } else {
          // 没有选中的HCP，直接过滤form.seIds
          this.form.seIds = this.form.seIds.filter(seId => validSeIds.includes(seId));
        }
      } else {
        // 取消勾选时，恢复原始seList
        if (this.originalSeList) {
          this.seList = JSON.parse(JSON.stringify(this.originalSeList));
          this.originalSeList = null;
        }
        // 恢复form.seIds，确保与原始seList匹配
        const validSeIds = this.seList.map(se => se.SEID);
        this.form.seIds = this.form.seIds.filter(seId => validSeIds.includes(seId));
      }
    },
    
    // 处理联系人过滤
    handleContactsOnlyFilter() {
      if (this.form.contactsOnly) {
        // 保存原始的seList数据，只保存一次
        if (!this.originalSeList) {
          this.originalSeList = JSON.parse(JSON.stringify(this.seList));
        }
        
        // 过滤seList，只保留IsWeComEnabled为true的HCP
        const filteredSeList = this.seList.filter(item => item.IsWeComEnabled);
        this.seList = filteredSeList;
        
        // 重新赋值form.seIds，只保留过滤后的seList中存在的HCP ID
        const validSeIds = filteredSeList.map(item => item.SEID);
        this.form.seIds = this.form.seIds.filter(id => validSeIds.includes(id));
      } else {
        // 取消勾选，恢复原始的seList数据
        if (this.originalSeList) {
          this.seList = JSON.parse(JSON.stringify(this.originalSeList));
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0;
    display: flex;
    max-height: 67vh;
  }

  .el-scrollbar.dialog {
    min-width: auto;
  }
}

.el-form-item {
  margin-bottom: 20px !important;

  &.editor {
    margin-bottom: 0 !important;
  }

  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }
}

.footer {
  text-align: center;
}

.activity_options {
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
}

.el-row {
  .el-col {

    &.interaction-date-time,
    &.interaction-type {
      width: auto !important;
    }

    &.interaction-type {
      .el-form-item {
        min-width: 150px;
      }
    }
  }

  .times-select {
    width: 110px;
  }

  .datetime {
    display: flex;
    align-items: flex-end;

    .el-date-editor {
      &:first-child {
        width: 125px !important;
      }

      &:last-child {
        width: 110px !important;
      }

      .el-input__inner {
        padding-right: 10px !important;
      }

      &:first-child {
        margin-right: 5px;
      }
    }
  }
}

::v-deep.el-form .el-form-item.request-type .el-radio .el-radio__label {
  white-space: break-spaces;
  word-break: break-word;
  vertical-align: top;
  display: inline-block;
}

::v-deep {
  .el-form-item__label {
    padding: 10 !important;
  }
}

::v-deep .label-top .el-form-item__label {
  float: none;
  display: block;
  text-align: left;
  padding-bottom: 5px;
  width: 150px !important;
}

::v-deep .label-top .el-form-item__content {
  margin-left: 0 !important;
}

.el-form-item__content {
  width: 100% !important;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
}

::v-deep {
  .custom-confirm-dialog {
    .el-dialog__body {
      width: 100%;
      display: block;
      padding: 10px 30px;
      color: #000000;
    }
  }

}

.dialog.edit-wrapper {
  ::v-deep {
    .el-dialog__wrapper {
      .v-modal{
        position: fixed!important;
      }
    }

  }
}


.confirm-divider {
  width: 100%;
  height: 1px;
  background: #dddddd;
  margin: 20px 0;
}
</style>
